// src/stone/illustrations/PixInLoteIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PixInLoteIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 41",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#005C41",
          d: "m40.482 4.236-3.576 28.377-26.227-3.117-3.945-.469-.89-.106-.062-.007.148-1.244.129-1.077 1.155-8.015 2.02-17.005.123-1.035 8.06.957z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          stroke: "#1D232A",
          d: "m33 37.039-19.767-3.583-1.991-1.042.488-1.017 9.053-19.36 5.087-4.453.866-.06 7.981 4.007z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#E8E9EA", d: "M35.087 7.296 4.064 2.82.34 31.032l31.022 4.477z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M17.565 24.603c1.254-.229 2.379-1.014 2.959-2.077.435-.796.499-1.656.175-2.362-.606-1.323-1.732-1.522-2.935-1.697l.148-4.595a2.35 2.35 0 0 1 2.062 1.014.268.268 0 1 0 .444-.302 2.86 2.86 0 0 0-2.49-1.25l.032-.954a.27.27 0 0 0-.539-.017l-.034 1.038c-1.05.209-1.972.845-2.495 1.725-.435.736-.532 1.56-.27 2.26.4 1.064 1.397 1.353 2.588 1.542l-.169 5.194c-1.362.058-2.398-.884-2.639-1.904a.269.269 0 0 0-.523.124c.176.75.702 1.466 1.452 1.899.482.277 1.057.44 1.693.42l-.03.957a.27.27 0 1 0 .537.019zm-2.438-7.406c-.206-.547-.123-1.203.228-1.797.425-.718 1.162-1.242 2.014-1.444l-.142 4.43c-1.17-.194-1.827-.462-2.1-1.189m2.618 1.812c1.15.169 1.986.333 2.466 1.38.254.557.198 1.224-.16 1.88-.486.892-1.417 1.56-2.469 1.78z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M13.652 26.238c-1.014-.586-1.892-1.35-2.546-2.241-.985-1.339-1.398-2.887-1.16-4.36a.269.269 0 1 1 .532.085c-.217 1.348.15 2.716 1.062 3.956 1.231 1.676 3.313 2.872 5.57 3.198 1.81.262 3.7-.307 5.188-1.56 1.66-1.4 2.61-3.451 2.67-5.777.094-3.54-2.378-6.737-6.01-7.776-3.594-1.027-6.941.406-8.953 3.835-.31.527-1.32 2.424-1.314 4.713a.269.269 0 0 1-.537.002c-.006-2.425 1.06-4.429 1.386-4.986 2.526-4.303 6.597-4.928 9.564-4.08 3.868 1.107 6.5 4.523 6.402 8.309-.066 2.481-1.082 4.673-2.861 6.174-1.605 1.353-3.65 1.965-5.612 1.68a9.6 9.6 0 0 1-3.38-1.172"
        }
      )
    ]
  }
);
var PixInLoteIllustration_default = PixInLoteIllustration;

export {
  PixInLoteIllustration_default
};
